// src/utils/authHelper.js
import { ElMessage } from 'element-plus';

// 统一 401/未授权处理，替代各 utils 中引用未定义 useAuthStore.dispatch("FedLogOut") 的错误写法。
// scope: 'user' → 跳 /Login；'admin' → 跳 /LoginAdmin。
export function handleUnauthorized(scope = 'user') {
  ElMessage.error('登录已失效，请重新登录');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('admin');
  window.location.href = scope === 'admin' ? '/LoginAdmin' : '/Login';
}
